import type { RouteRecordRaw, RouteComponent } from 'vue-router'
import type { RouteMiddleware } from '#app'
import { PageTypes } from '@core/constants/pages'
import { CURRENCIES } from '@gifsa/language-utils/routes'

const middleware: RouteMiddleware = async (to) => {
  if (to.params.amount && to.name) {
    return navigate(
      { name: to.name, query: to.query, params: { ...to.params, amount: '' } },
      { replace: true, redirectCode: 301 },
    )
  }
}

export function getCurrencyRoutes(component: RouteComponent): RouteRecordRaw[] {
  return CURRENCIES.map(
    ({ url, lang }): RouteRecordRaw => ({
      name: `currency-${lang}`,
      path: joinRoute(url, ':currencyFrom', ':currencyTo', ':amount?'),
      meta: { pageType: PageTypes.CURRENCY, lang, middleware },
      component,
    }),
  )
}
